export const SET_APPROVAL_PERMISSION = 'SET_APPROVAL_PERMISSION';
export const SET_APPROVAL_PERMISSION_SUCCESS = 'SET_APPROVAL_PERMISSION_SUCCESS';
export const SET_APPROVAL_PERMISSION_FAILED = 'SET_APPROVAL_PERMISSION_FAILED';

export const DELETE_APPROVAL_PERMISSION = 'DELETE_APPROVAL_PERMISSION';
export const DELETE_APPROVAL_PERMISSION_SUCCESS = 'DELETE_APPROVAL_PERMISSION_SUCCESS';
export const DELETE_APPROVAL_PERMISSION_FAILED = 'DELETE_APPROVAL_PERMISSION_FAILED';

export const GET_APPROVAL_PERMISSION = 'GET_APPROVAL_PERMISSION';
export const GET_APPROVAL_PERMISSION_SUCCESS = 'GET_APPROVAL_PERMISSION_SUCCESS';
export const GET_APPROVAL_PERMISSION_FAILED = 'GET_APPROVAL_PERMISSION_FAILED';

export const APPROVED_DOCUMENT = 'APPROVED_DOCUMENT';
export const APPROVED_DOCUMENT_SUCCESS = 'APPROVED_DOCUMENT_SUCCESS';
export const APPROVED_DOCUMENT_FAILED = 'APPROVED_DOCUMENT_FAILED';